// Loading indicator for a metrics panel. Counts in-flight card requests on
// the panel element and holds .m-busy on it while any are pending, so a
// filter change shows an "Updating" bar and dims the stale cards until the
// new numbers land. Picker (option) fetches are not tracked.
const pending = new WeakMap()

export default function trackBusy(el, promise) {
  if (!el) return promise
  pending.set(el, (pending.get(el) || 0) + 1)
  el.classList.add('m-busy')
  const done = () => {
    const left = Math.max(0, (pending.get(el) || 1) - 1)
    pending.set(el, left)
    if (left === 0) el.classList.remove('m-busy')
  }
  promise.then(done, done)
  return promise
}
